import { render, staticRenderFns } from "./batch-payment.vue?vue&type=template&id=a407d3ea"
import script from "./batch-payment.vue?vue&type=script&lang=js"
export * from "./batch-payment.vue?vue&type=script&lang=js"
import style0 from "./batch-payment.vue?vue&type=style&index=0&id=a407d3ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports